import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const activities = [
{
name:"Matt Morgan",
img:"user-38.jpg",
text:"Added New Project",
project:"HRMS Dashboard",
time:"05:30 PM"
},
{
name:"Jay Ze",
img:"user-01-1.jpg",
text:"Commented on Uploaded Document",
time:"05:00 PM"
},
{
name:"Mary Donald",
img:"user-19.jpg",
text:"Approved Task Projects",
time:"05:30 PM"
},
{
name:"George David",
img:"user-11-1.jpg",
text:"Requesting Access to Module Tickets",
time:"06:00 PM"
},
{
name:"Aaron Zeen",
img:"user-20.jpg",
text:"Downloaded App Reports",
time:"06:30 PM"
},
{
name:"Hendry Daniel",
img:"user-08.jpg",
text:"Completed New Project HMS",
time:"05:30 PM"
}
];

export default function RecentActivitiesCard(){

return(

<Card className="recent-card w-100">

<Card.Header className="recent-header">

<h5>Recent Activities</h5>



<Button
  as={Link}
  to="/activity"
  variant="light"
  size="sm"
  className="text-decoration-none"
>
  View All
</Button>

</Card.Header>

<Card.Body className="recent-body">

{activities.map((item,i)=>(
<div key={i} className="activity-row">

<img
src={`/assets/img/users/${item.img}`}
alt={item.name}
/>

<div className="activity-content">

<div className="activity-top">

<h6>{item.name}</h6>

<span className="time">{item.time}</span>

</div>

<p>
{item.text}
{item.project && (
<span className="project"> {item.project}</span>
)}
</p>

</div>

</div>
))}

</Card.Body>

<style>
{`

.recent-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
}

.recent-header{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px 20px;
background:#fff;
border-bottom:1px solid #e5e7eb;
}

.recent-header h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

.view-btn{
font-size:13px;
padding:5px 14px;
border:1px solid #e5e7eb;
background:#f9fafb;
}

.recent-body{
padding:18px 20px;
}

.activity-row{
display:flex;
align-items:flex-start;
gap:12px;
margin-bottom:20px;
}

.activity-row:last-child{
margin-bottom:0;
}

.activity-row img{
width:44px;
height:44px;
border-radius:50%;
object-fit:cover;
}

.activity-content{
flex:1;
}

.activity-top{
display:flex;
justify-content:space-between;
align-items:center;
margin-bottom:2px;
}

.activity-top h6{
margin:0;
font-size:15px;
font-weight:600;
color:#111827;
}

.time{
font-size:13px;
color:#6b7280;
}

.activity-content p{
margin:0;
font-size:14px;
color:#6b7280;
}

.project{
color:#ff5a1f;
font-weight:500;
}

`}
</style>

</Card>

)

}